import React from 'react';
import { compose, withHandlers, withProps, withPropsOnChange } from 'recompose';
import { last, isEqual, get } from 'lodash';
import LanguageMultiSelectField from '../../../common/LanguageMultiSelect';
import SelectField from '../../../common/ModernSelect';
import defaultSupportedLanguages from '../../../common/LanguageMultiSelect/supportedLanguages';
import { brandSupportedLanguagesOption } from '../constants';

const ShopLanguageSettings = ({ defaultLanguageOptions, isOptionDisabled }) => (
  <div className="c-wrapper-horizontal">
    <div className="layout">
      <LanguageMultiSelectField
        label="Supported Languages"
        name="settings.supportedLanguages"
        options={[
          brandSupportedLanguagesOption,
          ...defaultSupportedLanguages,
        ]}
        isOptionDisabled={isOptionDisabled}
      />
      <SelectField
        label="Shop default Language"
        name="settings.defaultLanguage"
        options={defaultLanguageOptions}
      />
    </div>
  </div>
);

export default compose(
  withProps((props) => {
    const supportedLanguages = props.supportedLanguages || [];
    // last selected option comes last
    const isBrandSupportedLanguagesSelected = last(supportedLanguages) === brandSupportedLanguagesOption;
    const defaultLanguageOptions = isBrandSupportedLanguagesSelected
      ? props.brandSupportedLanguages
      : supportedLanguages;

    return ({
      supportedLanguages,
      isBrandSupportedLanguagesSelected,
      defaultLanguageOptions: defaultLanguageOptions.filter(option => option !== brandSupportedLanguagesOption),
    });
  }),
  withPropsOnChange(['isBrandSupportedLanguagesSelected', 'supportedLanguages'], (props) => {
    if (isEqual(props.supportedLanguages, get(props, 'initialValues.settings.supportedLanguages'))) {
      return;
    }

    const hasBrandSupportedLanguage = props.supportedLanguages.includes(brandSupportedLanguagesOption);
    const userSelectNonBrandLanguage = hasBrandSupportedLanguage && !props.isBrandSupportedLanguagesSelected;

    if (userSelectNonBrandLanguage) {
      props.change(
        'settings.supportedLanguages',
        props.supportedLanguages.filter(option => option !== brandSupportedLanguagesOption),
      );
    }

    if (props.isBrandSupportedLanguagesSelected) {
      const isAllBrandLanguagesSelected = props.brandSupportedLanguages.every(
        ({ value }) => props.supportedLanguages.some(option => option.value === value)
      );
      const selectedLanguagesIncludesOnlyBrandLanguages = props.supportedLanguages.every(
        ({ value }) => props.brandSupportedLanguages.some(option => option.value === value)
      );

      // mark all brand languages as selected

      if (!isAllBrandLanguagesSelected || !selectedLanguagesIncludesOnlyBrandLanguages) {
        props.change('settings.supportedLanguages', [
          ...props.brandSupportedLanguages,
          brandSupportedLanguagesOption,
        ]);
      }
    }
  }),
  withPropsOnChange(['supportedLanguages'], (props) => {
    if (!props.defaultLanguageOptions.includes(props.defaultLanguage)) {
      props.change('settings.defaultLanguage', props.defaultLanguageOptions[0]);
    }
  }),
  withHandlers({
    isOptionDisabled: props => ({ value }) => {
      if ((props.supportedLanguages || []).includes(brandSupportedLanguagesOption)) {
        return props.brandSupportedLanguages
            .filter(option => option !== brandSupportedLanguagesOption)
            .some(brandOption => brandOption.value === value);
      }

      return value === 'en';
    },
  })
)(ShopLanguageSettings);
